module.exports = __webpack_public_path__ + "img/print_heartprint.8ebdc5f.webp";